import ImageGallery from "react-image-gallery";
import { images } from "../contants";
import * as sc from "../styled/scGallery";
import Reveal from "./Reveal";
import "react-image-gallery/styles/css/image-gallery.css";
import "../styled/Gallery.css";

function Gallery() {
  return (
    <sc.Gallery id="gallery">
      <header>
        <Reveal>
          <sc.TitleWrapper>
            <h1>Galeri</h1>
          </sc.TitleWrapper>
        </Reveal>
      </header>
      <Reveal delay={100}>
        <sc.GalleryWrapper>
          <ImageGallery items={images} autoPlay={false} showThumbnails={true} />
        </sc.GalleryWrapper>
      </Reveal>
    </sc.Gallery>
  );
}

export default Gallery;
